module.exports = __webpack_public_path__ + "img/rexall-trileaf-logo.4227f21f.png";